"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _attributeIds = require("@devsontap/nica-api/core/utils/attributeIds");

var _loading = _interopRequireDefault(require("../../../../_common/loading"));

var _attributeSection = _interopRequireDefault(require("./attributeSection"));

var _customField = _interopRequireDefault(require("../../../../_common/formik/customField"));

var _attributes = require("../../../../../redux/attributes");

var _actions = require("../../../../../redux/attributes/actions");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Attributes = function Attributes(_ref) {
  var setFieldValue = _ref.setFieldValue;

  var _useAttributeListSele = (0, _attributes.useAttributeListSelector)(),
      loading = _useAttributeListSele.loading,
      attributeIds = _useAttributeListSele.attributeIds;

  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    if (!attributeIds) {
      dispatch((0, _actions.loadAttributes)());
    }
  }, [dispatch]); // eslint-disable-line react-hooks/exhaustive-deps

  return loading ? /*#__PURE__*/_react.default.createElement(_loading.default, {
    size: 45
  }) : attributeIds && attributeIds.map(function (attributeId, index) {
    return attributeId !== _attributeIds.medicationsAvailable && /*#__PURE__*/_react.default.createElement(_customField.default, {
      CustomComponent: _attributeSection.default,
      name: "attributes.".concat(attributeId),
      key: "attribute-section-".concat(attributeId),
      attributeId: attributeId,
      errorField: "choice",
      setFieldValue: setFieldValue,
      fast: true
    });
  });
};

var _default = Attributes;
exports.default = _default;